import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ISearchFilterState {
  categorySearch: string[];
  disciplineSearch: string[];
  activeSearchString: string | null;
  setActiveSearchString: (searchString: string | null) => void;
  setCategorySearch: (category: string[]) => void;
  addCategorySearch: (category: string) => void;
  removeCategorySearch: (category: string) => void;
  setDisciplineSearch: (discipline: string[]) => void;
  addDisciplineSearch: (discipline: string) => void;
  removeDisciplineSearch: (discipline: string) => void;
  resetFilterSearch: () => void;
}

export const searchFilterStore = create<ISearchFilterState>()(
  persist(
    (set) => ({
      categorySearch: [],
      disciplineSearch: [],
      activeSearchString: null,
      setActiveSearchString: (searchString: string | null) => set({ activeSearchString: searchString }),
      setCategorySearch: (category: string[]) => set({ categorySearch: category }),
      addCategorySearch: (category: string) => set((state) => ({ categorySearch: [...state.categorySearch, category] })),
      removeCategorySearch: (category: string) => set((state) => ({ categorySearch: state.categorySearch.filter(it => it !== category) })),
      setDisciplineSearch: (discipline: string[]) => set({ disciplineSearch: discipline}),
      addDisciplineSearch: (discipline: string) => set((state) => ({ disciplineSearch: [...state.disciplineSearch, discipline] })),
      removeDisciplineSearch: (discipline: string) => set((state) => ({ disciplineSearch: state.disciplineSearch.filter(it => it !== discipline) })),
      resetFilterSearch: () => set({
        categorySearch: [],
        disciplineSearch: [],
        activeSearchString: null
      })
    }),
    {
      name: 'search-filters'
    }
  )
);